import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface DeduplicateDetail {
    athlete: string;
    event_type: string;
    meet_date: string;
    result_value: number;
    total_copies: number;
    duplicates_to_archive: number;
}

interface DeduplicateResponse {
    success: boolean;
    dry_run: boolean;
    duplicate_groups: number;
    total_duplicates: number;
    archived_count: number;
    details: DeduplicateDetail[];
}

interface DeduplicateFilters {
    'filter.group'?: string;
    'filter.individual'?: string;
    dry_run?: boolean;
}

type ReturnType = Promise<AxiosResponse<DeduplicateResponse>>;

const deduplicateTrackEvents = (filters: DeduplicateFilters = {}): ReturnType => {
    return Request.post('/workouts/track-events/deduplicate', filters);
};

export default deduplicateTrackEvents;
